import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {AdminService} from '../../components/admin/services/admin.service';
import {UserData} from '../../config/globals/userData.global';

@Injectable()
export class AdminAuth implements CanActivate {

  constructor(private adminService:AdminService,
              private userData:UserData) {
  }

  canActivate(user: any, id: any):Promise<boolean> {
    let bensl = this.userData.getBensl();
    return new Promise(resolve => {
      this.adminService.isAdmin(bensl).subscribe(
        (isAdmin:boolean) => {
          resolve(isAdmin)
        }
      );
    })
  }
}
